



















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { appName } from '@/env';
import { readLoginError } from '@/store/main/getters';
import { dispatchLogIn } from '@/store/main/actions';

@Component({
  metaInfo() {
    return {
      title: 'Login'
    };
  }
})
export default class Login extends Vue {
  public email: string = '';
  public password: string = '';
  public otpcode: string = '';
  public appName = appName;

  public get otpstep() {
    if (
      this.loginError === '2FACodeRequired' ||
      this.loginError === 'Incorrect2FACode'
    ) {
      return 1;
    } else {
      return 0;
    }
  }

  public get loginError() {
    return readLoginError(this.$store);
  }

  public verify() {
    dispatchLogIn(this.$store, {
      username: this.email,
      password: this.password,
      otpcode: this.otpcode
    });
  }

  public mounted() {
    // Focus on username
    (this.$refs.login as any).focus();
  }
}
